<div class="dsgn-dscp st-dsgn-dscp">
  <div class="row">
    <div class="col-sm-12">
      <h3 class="cs-dsgn-ttl">Upload Custom Product Images</h3>
      <button class="closedialog cls-dlg-cls" mat-dialog-close="false" mat-button (click)="onclose()"><i
          class="material-icons">close</i></button>
    </div>
  </div>

  <form [formGroup]="uploadForm" (ngSubmit)="fn_UploadFormSubmit(uploadForm)">
    <mat-dialog-content>
      <div [style.display]="cropperReady ? null : 'none'">
        <button class="margin-5px" type="button" mat-raised-button (click)="fn_AddImage()">Crop</button>
        <button class="margin-5px" type="button" mat-raised-button (click)="fn_CancelCrop()">Cancel</button>
        <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true" [aspectRatio]="1/ 1"
          [resizeToWidth]="500" format="jpeg" (imageCropped)="imageCropped($event)" (imageLoaded)="imageLoaded()"
          (loadImageFailed)="loadImageFailed()">
        </image-cropper>
      </div>
      <mat-card-content>
        <input #inputImage class="inputImage" formControlName="file" type="file" (change)="fn_OnFileChange($event, true)" accept=".jpg,.png,.jpeg">
        <input #inputImageEdit id="inputImageEdit" type="file" (change)="fn_OnFileChange($event, false)" accept=".jpg,.png,.jpeg" style="display: none;">
        <mat-hint align="start">*Image size should be less than 10 MB</mat-hint>
      </mat-card-content>
      <div>
        <div class="img-upload-container" *ngFor='let img of images; let i = index;' [ngClass]="{'disableDiv': img.IsDefault}">
          <img [src]="img.Image" class="img-upload-thumbnail">          
          <mat-checkbox class="chk-image-active" [value]="img.IsActive" [checked]="img.IsActive" (change)="fn_MakeImageActive($event,i)" (click)="fn_CheckLeastActive($event,i)" [matTooltip]="img.IsActive ? 'Active' : 'In-Active'"></mat-checkbox>
          <!-- <mat-radio-group class="radio-default-image" aria-label="Select default image" name="DefaultImgRadio">
            <mat-radio-button matTooltip="Set Default Image" [value]="img.IsDefault" [checked]="img.IsDefault == true" (click)="fn_MakeImageDefault(img)"></mat-radio-button>
          </mat-radio-group>  -->
          <a *ngIf="img.IsCustom" class="edit-icon icon-style" (click)="fn_EditImage(i, img.Id)" matTooltip="Edit">
            <label for="inputImageEdit">
              <i class="material-icons">
                edit
              </i>
            </label>
          </a>
          <a *ngIf="img.IsCustom" class="delete-icon icon-style" (click)="fn_DeleteImage(i, img.Id)" matTooltip="Delete">
            <i class="material-icons">
              delete_forever
            </i>
          </a>
       </div>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button type="submit" class="pblsh-mat-btn" mat-raised-button [disabled]="!isSomeAction">Save</button>
    </mat-dialog-actions>
  </form>
</div>